import { render, staticRenderFns } from "./ta-info-dialog.vue?vue&type=template&id=07719b8c&scoped=true"
import script from "./ta-info-dialog.vue?vue&type=script&lang=js"
export * from "./ta-info-dialog.vue?vue&type=script&lang=js"
import style0 from "./ta-info-dialog.vue?vue&type=style&index=0&id=07719b8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07719b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07719b8c')) {
      api.createRecord('07719b8c', component.options)
    } else {
      api.reload('07719b8c', component.options)
    }
    module.hot.accept("./ta-info-dialog.vue?vue&type=template&id=07719b8c&scoped=true", function () {
      api.rerender('07719b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/ta-info-dialog.vue"
export default component.exports